const resizeCharts = function(charts = Highcharts.charts) {
    charts.filter(_.identity).forEach(chart => {
        try {
            chart.reflow();
        } catch (error) {
            // noop
        }
    });
};

export default resizeCharts;
